import {InjectionToken} from '@angular/core';

export const FILE_CONFIG = new InjectionToken('mydocma-file-config');

export interface FileConfig {
  apiUrl?: string;
}
